'use client';
import React, { ReactNode } from 'react';

import { ExperienceContextProvider } from '@/contexts/experienceContext';
import { ObserverContextProvider } from '@/contexts/observerContext';
import { VillageContextProvider } from '@/contexts/villageContext';
import { FilterContextProvider } from '@/contexts/filterContext';
import { GalleryProvider } from '@/hooks/useGalleryContext';
import { ChatProvider } from '@/hooks/useChatContext';
import { MapProvider } from '@/hooks/useMapContext';
import { FAQProvider } from '@/hooks/useFAQContext';
import { GlobalContextProvider } from '@/contexts/globalsContext';
import { UserContextProvider } from '@/contexts/userContext';
import { VillabookingProvider } from '@/hooks/useVillabookingContext';
import { DatePickerContextProvider } from '@/contexts/datePickerContext';

const Providers = ({ children }: { children: ReactNode }) => {
  return (
    <GlobalContextProvider>
      <UserContextProvider>
        <MapProvider>
          <ChatProvider>
            <FAQProvider>
              <GalleryProvider>
                <FilterContextProvider>
                  <DatePickerContextProvider>
                    <VillageContextProvider>
                      <ExperienceContextProvider>
                        <ObserverContextProvider>
                          <VillabookingProvider>
                            {children}
                          </VillabookingProvider>
                        </ObserverContextProvider>
                      </ExperienceContextProvider>
                    </VillageContextProvider>
                  </DatePickerContextProvider>
                </FilterContextProvider>
              </GalleryProvider>
            </FAQProvider>
          </ChatProvider>
        </MapProvider>
      </UserContextProvider>
    </GlobalContextProvider>
  );
};

export default Providers;
